import React from 'react';
import { Typography, AppBar, Toolbar, Button, withStyles, Menu, MenuItem } from '@material-ui/core';
import Span from "@material-ui/core/Box";
import Logo from '../../assets/Main-Logo.png'
import { userLogout } from '../../helper/commonFunction';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

const styles = (theme) => ({

    AccountBtnCss: { fontSize: 13, padding: "8px 16px", "&:hover": { background: 'none', boxShadow: 'none' } },
    AppBarCss: { borderTop: "3px solid #1b5e20", borderBottom: "1px solid #1b5e20", background: "#fff", boxShadow: "none", padding: '5px 16px', },
    ToolbarCss: { display: "flex", justifyContent: "space-between", alignItems: "center", minHeight:'50px' },
    PopoverwidthCss: { textAlign: "center", boxShadow: 'none' },
    SpanCss: { display: "flex", alignItems: "center", },
    LogoutBtnCss: { fontSize: 14, padding:'6px 32px'},
    MenuCss: { marginTop: 36, padding:'15px'},
    MenuItemCss:{ padding:'5px 35px'},
    
    supportLink:{textDecoration:'none', color:'#3d3d3d'},
    [theme.breakpoints.only('xs')]: {
        CheckCss: { marginTop: 0, },
    }
});

const Header = (props) => {
    const { classes, prps} = props;
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <AppBar position='fixed' className={classes.AppBarCss}>
            <Toolbar className={classes.ToolbarCss}>
                <Span className={classes.SpanCss}>
                    <img src={Logo} width='170' height="51" alt='Logo'/>
                </Span>
                <Span className={classes.displayCss}>
                    <Span>
                        <Button variant='text' aria-haspopup="true" className={classes.AccountBtnCss} onClick={handleClick} endIcon={<ArrowDropDownIcon />}>
                            Account
                        </Button>
                        <Menu
                            id="simple-menu"
                            anchorEl={anchorEl}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                            elevation={1}
                            className={classes.MenuCss}
                        >
                            <MenuItem onClick={()=>{userLogout(prps)}} className={classes.MenuItemCss}>
                                <Typography variant="caption">Logout</Typography>
                            </MenuItem>
                            <MenuItem onClick={handleClose} className={classes.MenuItemCss}>
                                <Typography variant="caption">
                                    <a 
                                        className={classes.supportLink} 
                                        href="mailto:support@betwext.com" 
                                        rel="noreferrer"
                                        target="_blank">
                                        Support
                                    </a>
                                </Typography>
                            
                            </MenuItem>
                        </Menu>
                    </Span>
                </Span>
            </Toolbar>
        </AppBar>
    );
}

export default withStyles(styles)(Header);